<template>
  <div class="user-list">
    <SearchBar v-bind="searchBar"/>
    <Table v-bind="table" class="page-table" isMark :batchDelete="false" @allMark="allMark" hiddenOperate height="400">
      <template slot="isQingteng" slot-scope="{scope}">
        {{ scope.isQingteng?' 青腾用户':'普通会员' }}
      </template>
      <template slot="isMark" slot-scope="{scope}">
        <span :class="{'is-mark': scope.isMark}">{{ scope.isMark?'已赋分':'否' }}</span>
      </template>
      <template slot="point" slot-scope="{scope}">
        {{ scope.point || 0 }}
      </template>
    </Table>
    <Dialogs title="一键赋分" :isShowDialog="isShowMark" width="30%" @handleClick="handleClick">
      <div slot="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="积分类型:" prop="name">
            <span>活动积分</span>
          </el-form-item>
          <el-form-item label="增加积分:" prop="point">
            <el-input-number v-model="ruleForm.point" controls-position="right" :min="0" :max="100"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
    </Dialogs>
  </div>
</template>

<script>
import Table from '@/components/page/Table.vue'
import SearchBar from '@/components/page/SearchBar.vue'
import Dialogs from '@/components/page/Dialogs.vue'
import { getUserList, addJoinUserMarks } from '@/api/activity'
const initParams = {
  nickName: '',
  phone: ''
}

export default {
  components: {
    Table,
    SearchBar,
    Dialogs
  },
  props: {
    activityId: Number
  },
  data () {
    return {
      ruleForm: {
        point: ''
      },
      rules: {
        point: [{ required: true, message: '请输入分值', trigger: 'blur' }]
      },
      params: { ...initParams },
      searchBar: {
        list: [{
          type: 'input',
          prop: 'nickName',
          label: 'ID/会员姓名',
          placeholder: '请输入ID/会员姓名'
        }, {
          type: 'input',
          prop: 'phone',
          label: '会员电话',
          placeholder: '请输入会员电话'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: (params) => {
            this.params = { ...this.params, ...params }
            this.initData()
          }
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      table: {
        selection: true, // 是否开启选择框
        index: true,
        // disableKey: 'xxx', // 是否可勾选字段
        tableInfo: [{
          key: 'userId',
          name: '会员ID',
          minWidth: 80
        }, {
          key: 'nickName',
          name: '会员姓名',
          minWidth: 80
        }, {
          key: 'phone',
          name: '会员电话',
          minWidth: 80
        }, {
          key: 'isQingteng',
          name: '会员等级',
          type: 'custom',
          minWidth: 80
        }, {
          key: 'isMark',
          name: '是否已加分',
          minWidth: 80
        }, {
          key: 'point',
          name: '加分值',
          type: 'custom',
          minWidth: 80
        }],
        tableData: []
      },
      markUserIds: [], // 赋分的用户id
      isShowMark: false
    }
  },
  mounted () {
    this.initData()
  },
  watch: {
    activityId () {
      this.initData()
    }
  },
  methods: {
    allMark (list) {
      this.markUserIds = list.map(user => user.userId)
      this.isShowMark = true
    },
    async initData () {
      const params = {...this.params, activityId: this.activityId}
      const {data} = await getUserList(params)
      const newdata = data.map(item => ({...item, isMark: Number(item.point) > 0 ? '是' : '否'}))
      this.$set(this.table, 'tableData', newdata)
    },
    resetList () {
      this.params = { ...initParams }
      this.initData()
    },
    handleClick (bol) {
      if (bol) {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.markUserIds.forEach(id => {
              this.table.tableData.forEach(user => {
                if (user.userId === id) {
                  this.$set(user, 'isMark', true)
                  const point = (user.point || 0) + this.ruleForm.point
                  this.$set(user, 'point', point)
                }
              })
            })
            this.isShowMark = false
            this.ruleForm.point = ''
          } else {
            console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$refs['ruleForm'].resetFields()
        this.isShowMark = false
      }
    },
    async save () {
      const userPoints = this.table.tableData.map(user => ({
        userId: user.userId,
        point: user.point
      }))
      await addJoinUserMarks({
        activityId: this.activityId,
        userPoints
      })
      this.$emit('update:isShowMark', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .operate-btn {
      margin-bottom: 10px;
    }
    .is-mark {
      color: #00af84;
    }
  }
</style>